/**
 * collection-sort-oos.js — Undress Code PL (motyw Showcase)
 * ---------------------------------------------------------------------------
 * Przenosi produkty niedostępne (.product-block.sold-out) na sam koniec CAŁEJ
 * kolekcji (nie tylko bieżącej strony). Działa jako odsprzężona nakładka:
 * NIE modyfikuje theme.js — reaguje na podmiany siatki przez MutationObserver,
 * a każdy błąd kończy się bezpiecznym fallbackiem do natywnej siatki motywu.
 *
 * Skrypt dołączany jest tylko gdy w ustawieniach sekcji aktywne jest
 * „Przenoś wyprzedane produkty na koniec kolekcji".
 *
 * Jak to działa (kolekcja wielostronicowa):
 *   1. odczytaj liczbę produktów (data-result-count) i wielkość strony,
 *   2. pobierz wszystkie strony (?page=N, jak natywny infinite-scroll motywu),
 *   3. stabilnie podziel: dostępne ++ niedostępne (kolejność w grupach = sort),
 *   4. wyrenderuj w realnej kolejności DOM (bez display:none → bez pustych
 *      placków na granicach wierszy float `clear:left`) z NUMEROWANĄ paginacją
 *      po stronie klienta (wirtualne strony nad pełną, posortowaną listą),
 *   5. re-inicjalizuj komponenty kart tak, jak robi to motyw po AJAX.
 *
 * Paginacja klienta odtwarza natywny markup (.pagination .page/.current/.next),
 * więc wygląda identycznie. Kliknięcia są przechwytywane (preventDefault +
 * stopPropagation), aby NIE uruchamiać natywnego handlera `.pagination a`
 * motywu. URL nie jest zmieniany (motyw nasłuchuje popstate — unikamy kolizji).
 */
(function () {
  'use strict';

  var SEL = {
    grid: '[data-infinite-scroll-results]',
    container: '[data-infinite-scroll-container]',
    scrollTo: '[data-ajax-scroll-to]',
    card: '.product-block',
    pagination: '.pagination',
    ajaxContainer: '[data-ajax-container]',
    components: '[data-components]',
    section: '[id^="shopify-section-"]'
  };

  var SOLD_OUT_CLASS = 'sold-out';
  var FLAG = 'oosSorted'; // grid.dataset.oosSorted  ->  [data-oos-sorted]
  var DEFAULT_PER_PAGE = 24;
  var MAX_PAGES = 20; // bezpiecznik: maks. liczba stron do pobrania jednorazowo
  var WINDOW = 2; // ile numerów stron po obu stronach bieżącej
  var DEBOUNCE_MS = 150;
  var LOADING_CLASS = 'cc-product-filter-container--loading'; // klasa ładowania motywu
  var DEFAULT_LABELS = { prev: '« Poprzedni', next: 'Kolejny »' };

  function $all(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getGrid(root) {
    root = root || document;
    if (root.matches && root.matches(SEL.grid)) return root;
    return root.querySelector(SEL.grid);
  }

  function isSoldOut(card) {
    return card.classList.contains(SOLD_OUT_CLASS);
  }

  // Stabilny podział: najpierw dostępne, potem niedostępne (kolejność w grupach
  // = sortowanie wybrane przez klienta).
  function reorder(cards) {
    var available = [];
    var soldOut = [];
    cards.forEach(function (card) {
      (isSoldOut(card) ? soldOut : available).push(card);
    });
    return available.concat(soldOut);
  }

  // Czy w oryginalnej kolejności jakikolwiek DOSTĘPNY występuje PO niedostępnym?
  // Jeśli nie — kolekcja jest już poprawnie ułożona, nie ma czego przestawiać.
  function needsReorder(cards) {
    var seenSold = false;
    for (var i = 0; i < cards.length; i++) {
      if (isSoldOut(cards[i])) {
        seenSold = true;
      } else if (seenSold) {
        return true;
      }
    }
    return false;
  }

  function pageUrl(page) {
    var u = new URL(window.location.href);
    u.searchParams.set('page', String(page));
    u.searchParams.delete('section_id'); // pobieramy pełną stronę, nie fragment sekcji
    return u.href;
  }

  // Pobiera jedną stronę kolekcji (z zachowaniem aktualnych filtrów/sortowania).
  // Zwraca karty zaadoptowane do bieżącego dokumentu oraz etykiety paginacji
  // (prev/next) odczytane z natywnego markupu — dla dokładnej lokalizacji.
  function fetchPage(page) {
    return fetch(pageUrl(page), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status + ' (strona ' + page + ')');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = $all(doc, SEL.grid + ' ' + SEL.card).map(function (node) {
          return document.importNode(node, true);
        });
        var prevA = doc.querySelector(SEL.pagination + ' .prev a');
        var nextA = doc.querySelector(SEL.pagination + ' .next a');
        return {
          cards: cards,
          prev: prevA ? prevA.textContent.trim() : null,
          next: nextA ? nextA.textContent.trim() : null
        };
      });
  }

  // Re-inicjalizacja komponentów dokładnie tak, jak motyw po swapie AJAX
  // (theme.js → initFilterResults). Idempotentna dzięki guardowi .cc-initialized,
  // więc karty już zainicjalizowane nie zostaną zbindowane podwójnie.
  function reinit(grid) {
    try {
      var host = grid.closest(SEL.components);
      var jq = window.jQuery;
      if (host && jq) {
        (host.getAttribute('data-components') || '').split(',').forEach(function (name) {
          name = name.trim();
          if (name) jq(document).trigger('cc:component:load', [name, host]);
        });
        if (window.theme && window.theme.inlineVideos && typeof window.theme.inlineVideos.init === 'function') {
          window.theme.inlineVideos.init(jq(host));
        }
      }
      if (window.theme && typeof window.theme.initAnimateOnScroll === 'function') {
        window.theme.initAnimateOnScroll();
      }
      // lazysizes i tak sam wykrywa nowe .lazyload, ale dajemy mu wyraźny sygnał
      if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
      }
    } catch (e) {
      /* re-init jest opcjonalny — jego brak nie psuje kolejności produktów */
    }
  }

  function setLoading(grid, on) {
    var box = grid.closest(SEL.ajaxContainer);
    if (box) box.classList.toggle(LOADING_CLASS, !!on);
  }

  // Usuwa natywną paginację motywu (numerowaną / infinite-scroll) — od tej chwili
  // kolejnością i stronami steruje nasza paginacja klienta. Nie rusza naszej.
  function removeServerPagination(grid) {
    var host = grid.closest(SEL.section) || document;
    $all(host, SEL.pagination).forEach(function (pag) {
      if (pag.classList.contains('oos-pagination')) return;
      if (pag.parentNode) pag.parentNode.removeChild(pag);
    });
    try {
      if (window.theme && typeof window.theme.unloadInfiniteScroll === 'function') {
        window.theme.unloadInfiniteScroll(window.jQuery ? window.jQuery(host) : undefined);
      }
    } catch (e) {
      /* brak infinite-scroll do wyłączenia — nieistotne */
    }
  }

  function clearCards(grid) {
    $all(grid, SEL.card).forEach(function (card) {
      if (card.parentNode) card.parentNode.removeChild(card);
    });
  }

  // ----- Numerowana paginacja po stronie klienta -----------------------------

  // Które numery stron pokazać: 1, ostatnia oraz okno bieżąca±WINDOW.
  function windowedPages(current, pages) {
    var set = {};
    set[1] = true;
    set[pages] = true;
    for (var n = current - WINDOW; n <= current + WINDOW; n++) {
      if (n >= 1 && n <= pages) set[n] = true;
    }
    return Object.keys(set).map(Number).sort(function (a, b) { return a - b; });
  }

  function pagerLink(label, targetPage, grid) {
    var a = document.createElement('a');
    a.href = '#';
    a.title = '';
    a.textContent = label;
    a.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation(); // NIE uruchamiaj natywnego handlera `.pagination a`
      goToPage(grid, targetPage);
    });
    return a;
  }

  function buildPager(grid, current, pages) {
    var host = grid.closest(SEL.container) || grid.parentNode;
    $all(host, '.oos-pagination').forEach(function (e) { if (e.parentNode) e.parentNode.removeChild(e); });
    if (pages <= 1) return;

    var labels = grid.__oosLabels || DEFAULT_LABELS;
    var wrap = document.createElement('div');
    wrap.className = 'pagination central small-gap-top content transparent oos-pagination';

    if (current > 1) {
      var prev = document.createElement('span');
      prev.className = 'prev';
      prev.appendChild(pagerLink(labels.prev || DEFAULT_LABELS.prev, current - 1, grid));
      wrap.appendChild(prev);
    }

    var nums = windowedPages(current, pages);
    var last = 0;
    nums.forEach(function (n) {
      if (last && n - last > 1) {
        var deco = document.createElement('span');
        deco.className = 'deco';
        deco.textContent = '…';
        wrap.appendChild(deco);
      }
      var span = document.createElement('span');
      span.className = 'page' + (n === current ? ' current' : '');
      if (n === current) {
        span.textContent = String(n);
      } else {
        span.appendChild(pagerLink(String(n), n, grid));
      }
      wrap.appendChild(span);
      last = n;
    });

    if (current < pages) {
      var next = document.createElement('span');
      next.className = 'next';
      next.appendChild(pagerLink(labels.next || DEFAULT_LABELS.next, current + 1, grid));
      wrap.appendChild(next);
    }

    grid.parentNode.insertBefore(wrap, grid.nextSibling);
  }

  // Renderuje wirtualną stronę `page` z przygotowanej, posortowanej listy.
  function renderPage(grid, page) {
    var ordered = grid.__oosOrdered || [];
    var perPage = grid.__oosPerPage || DEFAULT_PER_PAGE;
    var pages = Math.max(1, Math.ceil(ordered.length / perPage));
    page = Math.min(Math.max(1, page), pages);
    grid.__oosPage = page;

    clearCards(grid);
    var start = (page - 1) * perPage;
    var end = Math.min(start + perPage, ordered.length);
    var frag = document.createDocumentFragment();
    for (var i = start; i < end; i++) frag.appendChild(ordered[i]);
    grid.appendChild(frag);

    reinit(grid);
    buildPager(grid, page, pages);
  }

  function goToPage(grid, page) {
    renderPage(grid, page);
    var anchor = grid.closest(SEL.scrollTo) || grid.closest(SEL.container) || grid;
    try {
      var y = anchor.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
    } catch (e) {
      anchor.scrollIntoView();
    }
  }

  // Przestawia w miejscu karty już obecne w DOM (bez pobierania).
  function reorderInPlace(grid, cards) {
    if (!needsReorder(cards)) return;
    var frag = document.createDocumentFragment();
    reorder(cards).forEach(function (card) {
      frag.appendChild(card); // przenosi istniejący węzeł — handlery i stan zostają
    });
    grid.appendChild(frag);
    reinit(grid);
  }

  function process(grid) {
    if (!grid || grid.dataset[FLAG]) return; // już obsłużone / w trakcie
    grid.dataset[FLAG] = 'pending'; // guard ponownego wejścia (także dla observera)

    var cards = $all(grid, SEL.card);
    if (!cards.length) {
      grid.dataset[FLAG] = 'done';
      return;
    }

    var total = parseInt(grid.getAttribute('data-result-count'), 10);
    if (isNaN(total) || total < 1) total = cards.length;

    var perPage = parseInt(grid.getAttribute('data-products-per-page'), 10) || cards.length || DEFAULT_PER_PAGE;
    if (perPage < 1) perPage = DEFAULT_PER_PAGE;

    var pages = Math.max(1, Math.ceil(total / perPage));

    // Jedna strona → wszystko jest w DOM, wystarczy przestawić w miejscu.
    if (pages <= 1) {
      reorderInPlace(grid, cards);
      grid.dataset[FLAG] = 'done';
      return;
    }

    // Bardzo duża kolekcja → degraduj bezpiecznie: przestaw tylko bieżącą stronę,
    // zostaw natywną paginację (bez lawiny zapytań).
    if (pages > MAX_PAGES) {
      reorderInPlace(grid, cards);
      grid.dataset[FLAG] = 'done';
      return;
    }

    // Wiele stron → pobierz całość, posortuj, wyrenderuj z numerowaną paginacją.
    setLoading(grid, true);

    var jobs = [];
    for (var p = 1; p <= pages; p++) jobs.push(fetchPage(p));

    Promise.all(jobs)
      .then(function (results) {
        var allCards = [];
        var labels = { prev: null, next: null };
        results.forEach(function (r) {
          r.cards.forEach(function (card) { allCards.push(card); });
          if (!labels.prev && r.prev) labels.prev = r.prev;
          if (!labels.next && r.next) labels.next = r.next;
        });
        if (!allCards.length) throw new Error('Brak kart po pobraniu stron');

        // Jeśli i tak nic nie trzeba przestawiać → nie przejmujemy siatki ani
        // paginacji. Zostawiamy natywne zachowanie motywu nietknięte.
        if (!needsReorder(allCards)) {
          setLoading(grid, false);
          grid.dataset[FLAG] = 'done';
          return;
        }

        grid.__oosOrdered = reorder(allCards);
        grid.__oosPerPage = perPage;
        grid.__oosLabels = {
          prev: labels.prev || DEFAULT_LABELS.prev,
          next: labels.next || DEFAULT_LABELS.next
        };

        removeServerPagination(grid);
        renderPage(grid, 1);

        setLoading(grid, false);
        grid.dataset[FLAG] = 'done';
      })
      .catch(function (err) {
        if (window.console && window.console.warn) {
          window.console.warn('[oos-sort] fallback do natywnej siatki:', err);
        }
        // Awaryjnie: przestaw tylko bieżącą stronę, reszta motywu bez zmian.
        try {
          reorderInPlace(grid, cards);
        } catch (e) {
          /* nawet to się nie udało — zostawiamy DOM dokładnie jak był */
        }
        setLoading(grid, false);
        grid.dataset[FLAG] = 'done';
      });
  }

  // Po każdej podmianie siatki przez motyw (filtr / sortowanie / paginacja AJAX)
  // pojawia się ŚWIEŻY węzeł siatki bez naszej flagi → przetwarzamy go ponownie.
  function observe(initialGrid) {
    var root = initialGrid.closest(SEL.section) || initialGrid.closest(SEL.components) || document.body;
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        var grid = getGrid(root);
        if (grid && !grid.dataset[FLAG]) process(grid);
      }, DEBOUNCE_MS);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    var grid = getGrid(document);
    if (!grid) return; // nie jesteśmy na stronie z siatką kolekcji
    process(grid);
    observe(grid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();